import moment from 'moment';
export const API_MONTH_ID: string = 'YYYYMM';
export const API_DATE_FORMAT: string = 'YYYYMMDD';
export const API_DATE_TIME_FORMAT = 'YYYYMMDDTHH:mm:ss.SSS[Z]';
const API_TIME_FORMAT: string = 'HH:mm:ss.SSS';
export const UTC_DATE_TIME_FORMAT: string = 'YYYYMMDDTHH:mm:ss.SSSZ';
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export function momentFromApiDateTime(apiDate: APIDateTime): moment$Moment {
  return moment(apiDate, API_DATE_FORMAT + ' ' + API_TIME_FORMAT);
}
export function momentFromApiDate(apiDate: APIDate): moment$Moment {
  return moment(apiDate, API_DATE_FORMAT);
}
export function momentToApiDate(date: moment$Moment): string {
  return date.format(API_DATE_FORMAT);
}
export function momentFromApiTime(apiTime: string): moment$Moment {
  return moment(apiTime, API_TIME_FORMAT);
}
export function momentToApiTime(date: moment$Moment): string {
  return date.format(API_TIME_FORMAT);
}
export function apiDateToTimestamp(
  apiDate: (APIDate | null | undefined) | number,
): Timestamp | null | undefined {
  return apiDate ? moment(apiDate, API_DATE_FORMAT).valueOf() : null;
}
export const apiDateTimeToTimestamp = (apiDate: any): Timestamp | null | undefined =>
  apiDate ? moment.utc(apiDate, API_DATE_TIME_FORMAT).valueOf() : null;
export function timestampToApiDate(
  timestamp: (Timestamp | null | undefined) | string,
): APIDate | null | undefined {
  return timestamp ? moment(timestamp).format(API_DATE_FORMAT) : null;
}
export function apiDateToTrackingDate(date: APIDate | null | undefined): string | null | undefined {
  return date ? momentFromApiDate(date).format(DEFAULT_DATE_FORMAT) : null;
}
export function formatApiDate(apiDate: APIDate, format: string): string {
  return moment(apiDate, API_DATE_FORMAT).format(format);
}
export function formatApiTime(apiTime: string, format: string): string {
  return moment(apiTime, API_TIME_FORMAT).format(format);
}
export function getPeriodsMoment(date: moment$Moment): string {
  return date.hours() > 12 ? 'PM' : 'AM';
}
export function getDiffFromNowTo(expirationDateTime: string): number {
  const expiration = moment(expirationDateTime, UTC_DATE_TIME_FORMAT);
  const now = moment();
  now.utc();
  moment.utc(expiration.toString(), UTC_DATE_TIME_FORMAT);
  return Math.round(expiration.diff(now, 'hours', true));
}
